/**
 * Podcast Listing
 *
 * This component requires jQuery.
 * You can require it on the page using <div data-component="podcast-listing"></div>
 */
 function getSliderSetting(){
	return {
			rows: 0,
			dots: true,
			arrows: true,
			prevArrow: '<button class="slick-prev" aria-label="Previous" type="button"><i class="icon-p2-left"></i></button>',
			 nextArrow: '<button class="slick-next" aria-label="Next" type="button"><i class="icon-p2-right"></i></button>',
			slidesToShow: 3,
			swipeToSlide: false,
			slidesToScroll: 1,
			responsive: [
				{
					breakpoint: 1500,
					settings: {
						slidesToShow: 3,
						slidesToScroll: 1,
						// variableWidth: true,
					},
				},{
					breakpoint: 768,
					settings: {
						slidesToShow: 3,
						slidesToScroll: 1,
						// variableWidth: true,
					},
				},
				{
					breakpoint: 480,
					settings: {
						slidesToShow: 1,
						slidesToScroll: 1,
						// variableWidth: true,
					},
				},
			],
		}
}

$( function() {
	$( '[data-component="podcast-listing"]' ).each( function() {
		let $holder = $( this );
		// $( '.btn-load-more', $holder ).click( function( e ) {
		// 	e.preventDefault();
		// 	var seasons = $( "#seasons" ).val();
		// 	var button = $( this ),
		// 		data = {
		// 			'action': 'podcast',
		// 			'limit': limit,
		// 			'page': page,
		// 			'seasons': seasons
		// 		};
			
		// 		var maxpage = max_pages_latest;
				
		// 	$.ajax( {
		// 		url: podcast_params.ajaxurl,
		// 		data: data,
		// 		type: 'POST',
		// 		beforeSend: function( xhr ) {
		// 			button.text( 'Loading...' ); // change the button text, you can also add a preloader image
		// 		},
		// 		success: function( data ) {
		// 			if ( data ) {
		// 				$( ".podcast-section__list" ).append( data );
		// 				button.text( 'Load More' );
					
		// 				if ( page >= maxpage ) {
		// 					button.hide();
		// 				} else {button.show(); page ++;} // if last page, remove the button
		// 				} else {
		// 					button.hide(); // if no data, remove the button as well
		// 				}
		// 		}
		// 	} );
		// } );

		$( '#seasons', $holder ).change( function( e ) {
			e.preventDefault();
			var seasons = $( "#seasons" ).val();
			var button = $('.btn-load-more' ),
				data = {
					'action': 'podcast',
					'page': 1,
					'seasons': seasons
				};
					
			$.ajax( {
				url: podcast_params.ajaxurl,
				data: data,
				type: 'POST',
				beforeSend: function( xhr ) {
					$( ".podcast-section__list" ).html( 'Loading...' ); // change the button text, you can also add a preloader image
				},
				success: function( data ) {
					if ( data ) {
						$( ".podcast-section__list" ).html( data );
						$( ".postcast_carousel" ).slick(getSliderSetting());
						
						// button.text( 'Load More' );
						
						// if ( page >= max_pages_latest ) {
						// 	button.hide();
						// } else {button.show(); page=2;} // if last page, remove the button
						} else {
							// button.hide(); // if no data, remove the button as well
						}
					
				}
			} );
		} );

		

	} );
} );
